import { setData } from '@progress/kendo-angular-intl';
setData({
    name: "it",
    identity: {
        language: "it"
    },
    territory: "IT",
    numbers: {
        symbols: {
            decimal: ",",
            group: ".",
            list: ";",
            percentSign: "%",
            plusSign: "+",
            minusSign: "-",
            exponential: "E",
            superscriptingExponent: "×",
            perMille: "‰",
            infinity: "∞",
            nan: "NaN",
            timeSeparator: ":"
        },
        decimal: {
            patterns: [
                "n"
            ],
            groupSize: [
                3
            ]
        },
        scientific: {
            patterns: [
                "nEn"
            ],
            groupSize: []
        },
        percent: {
            patterns: [
                "n%"
            ],
            groupSize: [
                3
            ]
        },
        currency: {
            patterns: [
                "n $"
            ],
            groupSize: [
                3
            ],
            "unitPattern-count-one": "n $",
            "unitPattern-count-other": "n $"
        },
        accounting: {
            patterns: [
                "n $"
            ],
            groupSize: [
                3
            ]
        },
        currencies: {
            ADP: {
                displayName: "peseta andorrana",
                symbol: "ADP"
            },
            AED: {
                displayName: "dirham degli Emirati Arabi Uniti",
                "displayName-count-one": "dirham degli EAU",
                "displayName-count-other": "dirham degli EAU",
                symbol: "AED"
            },
            AFA: {
                displayName: "afgani (1927–2002)",
                symbol: "AFA"
            },
            AFN: {
                displayName: "afghani",
                "displayName-count-one": "afghani",
                "displayName-count-other": "afghani",
                symbol: "AFN"
            },
            ALK: {
                displayName: "ALK",
                symbol: "ALK"
            },
            ALL: {
                displayName: "lek albanese",
                "displayName-count-one": "lek albanese",
                "displayName-count-other": "lekë albanesi",
                symbol: "ALL"
            },
            AMD: {
                displayName: "dram armeno",
                "displayName-count-one": "dram armeno",
                "displayName-count-other": "dram armeni",
                symbol: "AMD"
            },
            ANG: {
                displayName: "fiorino delle Antille olandesi",
                "displayName-count-one": "fiorino delle Antille olandesi",
                "displayName-count-other": "fiorino delle Antille olandesi",
                symbol: "ANG"
            },
            AOA: {
                displayName: "kwanza angolano",
                "displayName-count-one": "kwanza angolano",
                "displayName-count-other": "kwanzas angolani",
                symbol: "AOA",
                "symbol-alt-narrow": "Kz"
            },
            AOK: {
                displayName: "kwanza angolano (1977–1990)",
                symbol: "AOK"
            },
            AON: {
                displayName: "nuovo kwanza angolano (1990–2000)",
                symbol: "AON"
            },
            AOR: {
                displayName: "kwanza reajustado angolano (1995–1999)",
                symbol: "AOR"
            },
            ARA: {
                displayName: "austral argentino",
                symbol: "ARA"
            },
            ARL: {
                displayName: "ARL",
                symbol: "ARL"
            },
            ARM: {
                displayName: "ARM",
                symbol: "ARM"
            },
            ARP: {
                displayName: "peso argentino (vecchio Cod.)",
                symbol: "ARP"
            },
            ARS: {
                displayName: "peso argentino",
                "displayName-count-one": "peso argentino",
                "displayName-count-other": "pesos argentini",
                symbol: "ARS",
                "symbol-alt-narrow": "$"
            },
            ATS: {
                displayName: "scellino austriaco",
                symbol: "ATS"
            },
            AUD: {
                displayName: "dollaro australiano",
                "displayName-count-one": "dollaro australiano",
                "displayName-count-other": "dollari australiani",
                symbol: "A$",
                "symbol-alt-narrow": "$"
            },
            AWG: {
                displayName: "fiorino di Aruba",
                "displayName-count-one": "fiorino di Aruba",
                "displayName-count-other": "fiorini di Aruba",
                symbol: "AWG"
            },
            AZM: {
                displayName: "manat azero (1993–2006)",
                symbol: "AZM"
            },
            AZN: {
                displayName: "manat azero",
                "displayName-count-one": "manat azero",
                "displayName-count-other": "manat azeri",
                symbol: "AZN"
            },
            BAD: {
                displayName: "dinar Bosnia-Herzegovina",
                symbol: "BAD"
            },
            BAM: {
                displayName: "marco convertibile della Bosnia-Herzegovina",
                "displayName-count-one": "marco convertibile della Bosnia-Herzegovina",
                "displayName-count-other": "marchi convertibili della Bosnia-Herzegovina",
                symbol: "BAM",
                "symbol-alt-narrow": "KM"
            },
            BAN: {
                displayName: "BAN",
                symbol: "BAN"
            },
            BBD: {
                displayName: "dollaro di Barbados",
                "displayName-count-one": "dollaro di Barbados",
                "displayName-count-other": "dollari di Barbados",
                symbol: "BBD",
                "symbol-alt-narrow": "$"
            },
            BDT: {
                displayName: "taka bangladese",
                "displayName-count-one": "taka bengalese",
                "displayName-count-other": "taka bengalesi",
                symbol: "BDT",
                "symbol-alt-narrow": "৳"
            },
            BEC: {
                displayName: "franco belga (convertibile)",
                symbol: "BEC"
            },
            BEF: {
                displayName: "franco belga",
                symbol: "BEF"
            },
            BEL: {
                displayName: "franco belga (finanziario)",
                symbol: "BEL"
            },
            BGL: {
                displayName: "lev bulgaro (1962–1999)",
                "displayName-count-one": "lev bulgaro (1962–1999)",
                "displayName-count-other": "leva bulgari (1962–1999)",
                symbol: "BGL"
            },
            BGM: {
                displayName: "BGM",
                symbol: "BGM"
            },
            BGN: {
                displayName: "lev bulgaro",
                "displayName-count-one": "lev bulgaro",
                "displayName-count-other": "leva bulgari",
                symbol: "BGN"
            },
            BGO: {
                displayName: "BGO",
                symbol: "BGO"
            },
            BHD: {
                displayName: "dinaro del Bahrein",
                "displayName-count-one": "dinaro del Bahrein",
                "displayName-count-other": "dinari del Bahrein",
                symbol: "BHD"
            },
            BIF: {
                displayName: "franco del Burundi",
                "displayName-count-one": "franco del Burundi",
                "displayName-count-other": "franchi del Burundi",
                symbol: "BIF"
            },
            BMD: {
                displayName: "dollaro delle Bermuda",
                "displayName-count-one": "dollaro delle Bermuda",
                "displayName-count-other": "dollari delle Bermuda",
                symbol: "BMD",
                "symbol-alt-narrow": "$"
            },
            BND: {
                displayName: "dollaro del Brunei",
                "displayName-count-one": "dollaro del Brunei",
                "displayName-count-other": "dollari del Brunei",
                symbol: "BND",
                "symbol-alt-narrow": "$"
            },
            BOB: {
                displayName: "boliviano",
                "displayName-count-one": "boliviano",
                "displayName-count-other": "boliviani",
                symbol: "BOB",
                "symbol-alt-narrow": "Bs"
            },
            BOL: {
                displayName: "BOL",
                symbol: "BOL"
            },
            BOP: {
                displayName: "peso boliviano",
                symbol: "BOP"
            },
            BOV: {
                displayName: "mvdol boliviano",
                symbol: "BOV"
            },
            BRB: {
                displayName: "cruzeiro novo brasiliano (1967–1986)",
                symbol: "BRB"
            },
            BRC: {
                displayName: "cruzado brasiliano",
                symbol: "BRC"
            },
            BRE: {
                displayName: "cruzeiro brasiliano (1990–1993)",
                symbol: "BRE"
            },
            BRL: {
                displayName: "real brasiliano",
                "displayName-count-one": "real brasiliano",
                "displayName-count-other": "real brasiliani",
                symbol: "BRL",
                "symbol-alt-narrow": "R$"
            },
            BRN: {
                displayName: "cruzado novo brasiliano",
                symbol: "BRN"
            },
            BRR: {
                displayName: "cruzeiro brasiliano",
                symbol: "BRR"
            },
            BRZ: {
                displayName: "BRZ",
                symbol: "BRZ"
            },
            BSD: {
                displayName: "dollaro delle Bahamas",
                "displayName-count-one": "dollaro delle Bahamas",
                "displayName-count-other": "dollari delle Bahamas",
                symbol: "BSD",
                "symbol-alt-narrow": "$"
            },
            BTN: {
                displayName: "ngultrum bhutanese",
                "displayName-count-one": "ngultrum bhutanese",
                "displayName-count-other": "ngultrum bhutanesi",
                symbol: "BTN"
            },
            BUK: {
                displayName: "kyat birmano",
                symbol: "BUK"
            },
            BWP: {
                displayName: "pula del Botswana",
                "displayName-count-one": "pula del Botswana",
                "displayName-count-other": "pula del Botswana",
                symbol: "BWP",
                "symbol-alt-narrow": "P"
            },
            BYB: {
                displayName: "nuovo rublo bielorusso (1994–1999)",
                symbol: "BYB"
            },
            BYN: {
                displayName: "rublo bielorusso",
                "displayName-count-one": "rublo bielorusso",
                "displayName-count-other": "rubli bielorussi",
                symbol: "BYN",
                "symbol-alt-narrow": "Br"
            },
            BYR: {
                displayName: "rublo bielorusso (2000–2016)",
                "displayName-count-one": "rublo bielorusso (2000–2016)",
                "displayName-count-other": "rubli bielorussi (2000–2016)",
                symbol: "BYR"
            },
            BZD: {
                displayName: "dollaro del Belize",
                "displayName-count-one": "dollaro del Belize",
                "displayName-count-other": "dollari del Belize",
                symbol: "BZD",
                "symbol-alt-narrow": "$"
            },
            CAD: {
                displayName: "dollaro canadese",
                "displayName-count-one": "dollaro canadese",
                "displayName-count-other": "dollari canadesi",
                symbol: "CA$",
                "symbol-alt-narrow": "$"
            },
            CDF: {
                displayName: "franco congolese",
                "displayName-count-one": "franco congolese",
                "displayName-count-other": "franchi congolesi",
                symbol: "CDF"
            },
            CHE: {
                displayName: "CHE",
                symbol: "CHE"
            },
            CHF: {
                displayName: "franco svizzero",
                "displayName-count-one": "franco svizzero",
                "displayName-count-other": "franchi svizzeri",
                symbol: "CHF"
            },
            CHW: {
                displayName: "CHW",
                symbol: "CHW"
            },
            CLE: {
                displayName: "CLE",
                symbol: "CLE"
            },
            CLF: {
                displayName: "unidades de fomento chilene",
                symbol: "CLF"
            },
            CLP: {
                displayName: "peso cileno",
                "displayName-count-one": "peso cileno",
                "displayName-count-other": "pesos cileni",
                symbol: "CLP",
                "symbol-alt-narrow": "$"
            },
            CNH: {
                displayName: "CNH",
                "displayName-count-one": "CNH",
                "displayName-count-other": "CNH",
                symbol: "CNH"
            },
            CNX: {
                displayName: "CNX",
                symbol: "CNX"
            },
            CNY: {
                displayName: "renminbi cinese",
                "displayName-count-one": "renmimbi cinese",
                "displayName-count-other": "renmimbi cinesi",
                symbol: "CN¥",
                "symbol-alt-narrow": "¥"
            },
            COP: {
                displayName: "peso colombiano",
                "displayName-count-one": "peso colombiano",
                "displayName-count-other": "pesos colombiani",
                symbol: "COP",
                "symbol-alt-narrow": "$"
            },
            COU: {
                displayName: "COU",
                symbol: "COU"
            },
            CRC: {
                displayName: "colón costaricano",
                "displayName-count-one": "colón costaricano",
                "displayName-count-other": "colón costaricani",
                symbol: "CRC",
                "symbol-alt-narrow": "₡"
            },
            CSD: {
                displayName: "antico dinaro serbo",
                symbol: "CSD"
            },
            CSK: {
                displayName: "corona forte cecoslovacca",
                symbol: "CSK"
            },
            CUC: {
                displayName: "peso cubano convertibile",
                "displayName-count-one": "peso cubano convertibile",
                "displayName-count-other": "pesos cubani convertibili",
                symbol: "CUC",
                "symbol-alt-narrow": "$"
            },
            CUP: {
                displayName: "peso cubano",
                "displayName-count-one": "peso cubano",
                "displayName-count-other": "pesos cubani",
                symbol: "CUP",
                "symbol-alt-narrow": "$"
            },
            CVE: {
                displayName: "escudo capoverdiano",
                "displayName-count-one": "escudo capoverdiano",
                "displayName-count-other": "escudos capoverdiani",
                symbol: "CVE"
            },
            CYP: {
                displayName: "sterlina cipriota",
                symbol: "CYP"
            },
            CZK: {
                displayName: "corona ceca",
                "displayName-count-one": "corona ceca",
                "displayName-count-other": "corone ceche",
                symbol: "CZK",
                "symbol-alt-narrow": "Kč"
            },
            DDM: {
                displayName: "ostmark della Germania Orientale",
                symbol: "DDM"
            },
            DEM: {
                displayName: "marco tedesco",
                symbol: "DEM"
            },
            DJF: {
                displayName: "franco di Gibuti",
                "displayName-count-one": "franco di Gibuti",
                "displayName-count-other": "franchi di Gibuti",
                symbol: "DJF"
            },
            DKK: {
                displayName: "corona danese",
                "displayName-count-one": "corona danese",
                "displayName-count-other": "corone danesi",
                symbol: "DKK",
                "symbol-alt-narrow": "kr"
            },
            DOP: {
                displayName: "peso dominicano",
                "displayName-count-one": "peso dominicano",
                "displayName-count-other": "pesos dominicani",
                symbol: "DOP",
                "symbol-alt-narrow": "$"
            },
            DZD: {
                displayName: "dinaro algerino",
                "displayName-count-one": "dinaro algerino",
                "displayName-count-other": "dinari algerini",
                symbol: "DZD"
            },
            ECS: {
                displayName: "sucre dell’Ecuador",
                symbol: "ECS"
            },
            ECV: {
                displayName: "unidad de valor constante (UVC) dell’Ecuador",
                symbol: "ECV"
            },
            EEK: {
                displayName: "corona dell’Estonia",
                symbol: "EEK"
            },
            EGP: {
                displayName: "sterlina egiziana",
                "displayName-count-one": "sterlina egiziana",
                "displayName-count-other": "sterline egiziane",
                symbol: "EGP",
                "symbol-alt-narrow": "£E"
            },
            ERN: {
                displayName: "nakfa eritreo",
                "displayName-count-one": "nakfa eritreo",
                "displayName-count-other": "nakfa eritrei",
                symbol: "ERN"
            },
            ESA: {
                displayName: "peseta spagnola account",
                symbol: "ESA"
            },
            ESB: {
                displayName: "peseta spagnola account convertibile",
                symbol: "ESB"
            },
            ESP: {
                displayName: "peseta spagnola",
                symbol: "ESP",
                "symbol-alt-narrow": "₧"
            },
            ETB: {
                displayName: "birr etiope",
                "displayName-count-one": "birr etiope",
                "displayName-count-other": "birr etiopi",
                symbol: "ETB"
            },
            EUR: {
                displayName: "euro",
                "displayName-count-one": "euro",
                "displayName-count-other": "euro",
                symbol: "€",
                "symbol-alt-narrow": "€"
            },
            FIM: {
                displayName: "markka finlandese",
                symbol: "FIM"
            },
            FJD: {
                displayName: "dollaro delle Figi",
                "displayName-count-one": "dollaro delle Figi",
                "displayName-count-other": "dollari delle Figi",
                symbol: "FJD",
                "symbol-alt-narrow": "$"
            },
            FKP: {
                displayName: "sterlina delle Falkland",
                "displayName-count-one": "sterlina delle Falkland",
                "displayName-count-other": "sterline delle Falkland",
                symbol: "FKP",
                "symbol-alt-narrow": "£"
            },
            FRF: {
                displayName: "franco francese",
                symbol: "FRF"
            },
            GBP: {
                displayName: "sterlina britannica",
                "displayName-count-one": "sterlina britannica",
                "displayName-count-other": "sterline britanniche",
                symbol: "£",
                "symbol-alt-narrow": "£"
            },
            GEK: {
                displayName: "kupon larit georgiano",
                symbol: "GEK"
            },
            GEL: {
                displayName: "lari georgiano",
                "displayName-count-one": "lari georgiano",
                "displayName-count-other": "lari georgiani",
                symbol: "GEL",
                "symbol-alt-narrow": "₾",
                "symbol-alt-variant": "ლ"
            },
            GHC: {
                displayName: "cedi del Ghana",
                symbol: "GHC"
            },
            GHS: {
                displayName: "cedi ghanese",
                "displayName-count-one": "cedi ghanese",
                "displayName-count-other": "cedi ghanesi",
                symbol: "GHS"
            },
            GIP: {
                displayName: "sterlina di Gibilterra",
                "displayName-count-one": "sterlina di Gibilterra",
                "displayName-count-other": "sterline di Gibilterra",
                symbol: "GIP",
                "symbol-alt-narrow": "£"
            },
            GMD: {
                displayName: "dalasi gambiano",
                "displayName-count-one": "dalasi gambiano",
                "displayName-count-other": "dalasi gambiani",
                symbol: "GMD"
            },
            GNF: {
                displayName: "franco della Guinea",
                "displayName-count-one": "franco della Guinea",
                "displayName-count-other": "franchi della Guinea",
                symbol: "GNF",
                "symbol-alt-narrow": "FG"
            },
            GNS: {
                displayName: "syli della Guinea",
                symbol: "GNS"
            },
            GQE: {
                displayName: "ekwele della Guinea Equatoriale",
                symbol: "GQE"
            },
            GRD: {
                displayName: "dracma greca",
                symbol: "GRD"
            },
            GTQ: {
                displayName: "quetzal guatemalteco",
                "displayName-count-one": "quetzal guatemalteco",
                "displayName-count-other": "quetzal guatemaltechi",
                symbol: "GTQ",
                "symbol-alt-narrow": "Q"
            },
            GWE: {
                displayName: "escudo della Guinea portoghese",
                symbol: "GWE"
            },
            GWP: {
                displayName: "peso della Guinea-Bissau",
                symbol: "GWP"
            },
            GYD: {
                displayName: "dollaro della Guyana",
                "displayName-count-one": "dollaro della Guyana",
                "displayName-count-other": "dollari della Guyana",
                symbol: "GYD",
                "symbol-alt-narrow": "$"
            },
            HKD: {
                displayName: "dollaro di Hong Kong",
                "displayName-count-one": "dollaro di Hong Kong",
                "displayName-count-other": "dollari di Hong Kong",
                symbol: "HKD",
                "symbol-alt-narrow": "$"
            },
            HNL: {
                displayName: "lempira honduregna",
                "displayName-count-one": "lempira honduregna",
                "displayName-count-other": "lempire honduregne",
                symbol: "HNL",
                "symbol-alt-narrow": "L"
            },
            HRD: {
                displayName: "dinaro croato",
                symbol: "HRD"
            },
            HRK: {
                displayName: "kuna croata",
                "displayName-count-one": "kuna croata",
                "displayName-count-other": "kune croate",
                symbol: "HRK",
                "symbol-alt-narrow": "kn"
            },
            HTG: {
                displayName: "gourde haitiano",
                "displayName-count-one": "gourde haitiano",
                "displayName-count-other": "gourde haitiani",
                symbol: "HTG"
            },
            HUF: {
                displayName: "fiorino ungherese",
                "displayName-count-one": "fiorino ungherese",
                "displayName-count-other": "fiorini ungheresi",
                symbol: "HUF",
                "symbol-alt-narrow": "Ft"
            },
            IDR: {
                displayName: "rupia indonesiana",
                "displayName-count-one": "rupia indonesiana",
                "displayName-count-other": "rupie indonesiane",
                symbol: "IDR",
                "symbol-alt-narrow": "Rp"
            },
            IEP: {
                displayName: "sterlina irlandese",
                symbol: "IEP"
            },
            ILP: {
                displayName: "sterlina israeliana",
                symbol: "ILP"
            },
            ILR: {
                displayName: "ILR",
                symbol: "ILR"
            },
            ILS: {
                displayName: "nuovo siclo israeliano",
                "displayName-count-one": "nuovo siclo israeliano",
                "displayName-count-other": "nuovi sicli israeliani",
                symbol: "₪",
                "symbol-alt-narrow": "₪"
            },
            INR: {
                displayName: "rupia indiana",
                "displayName-count-one": "rupia indiana",
                "displayName-count-other": "rupie indiane",
                symbol: "₹",
                "symbol-alt-narrow": "₹"
            },
            IQD: {
                displayName: "dinaro iracheno",
                "displayName-count-one": "dinaro iracheno",
                "displayName-count-other": "dinari iracheni",
                symbol: "IQD"
            },
            IRR: {
                displayName: "rial iraniano",
                "displayName-count-one": "rial iraniano",
                "displayName-count-other": "rial iraniani",
                symbol: "IRR"
            },
            ISJ: {
                displayName: "ISJ",
                symbol: "ISJ"
            },
            ISK: {
                displayName: "corona islandese",
                "displayName-count-one": "corona islandese",
                "displayName-count-other": "corone islandesi",
                symbol: "ISK",
                "symbol-alt-narrow": "kr"
            },
            ITL: {
                pattern: "¤ #,##0.00",
                displayName: "lira italiana",
                symbol: "ITL",
                decimal: ",",
                group: "."
            },
            JMD: {
                displayName: "dollaro giamaicano",
                "displayName-count-one": "dollaro giamaicano",
                "displayName-count-other": "dollari giamaicani",
                symbol: "JMD",
                "symbol-alt-narrow": "$"
            },
            JOD: {
                displayName: "dinaro giordano",
                "displayName-count-one": "dinaro giordano",
                "displayName-count-other": "dinari giordani",
                symbol: "JOD"
            },
            JPY: {
                displayName: "yen giapponese",
                "displayName-count-one": "yen giapponese",
                "displayName-count-other": "yen giapponesi",
                symbol: "JPY",
                "symbol-alt-narrow": "¥"
            },
            KES: {
                displayName: "scellino keniota",
                "displayName-count-one": "scellino keniota",
                "displayName-count-other": "scellini keniota",
                symbol: "KES"
            },
            KGS: {
                displayName: "som kirghiso",
                "displayName-count-one": "som kirghiso",
                "displayName-count-other": "som kirghisi",
                symbol: "KGS"
            },
            KHR: {
                displayName: "riel cambogiano",
                "displayName-count-one": "riel cambogiano",
                "displayName-count-other": "riel cambogiani",
                symbol: "KHR",
                "symbol-alt-narrow": "៛"
            },
            KMF: {
                displayName: "franco comoriano",
                "displayName-count-one": "franco comoriano",
                "displayName-count-other": "franchi comoriani",
                symbol: "KMF",
                "symbol-alt-narrow": "CF"
            },
            KPW: {
                displayName: "won nordcoreano",
                "displayName-count-one": "won nordcoreano",
                "displayName-count-other": "won nordcoreani",
                symbol: "KPW",
                "symbol-alt-narrow": "₩"
            },
            KRH: {
                displayName: "KRH",
                symbol: "KRH"
            },
            KRO: {
                displayName: "KRO",
                symbol: "KRO"
            },
            KRW: {
                displayName: "won sudcoreano",
                "displayName-count-one": "won sudcoreano",
                "displayName-count-other": "won sudcoreani",
                symbol: "KRW",
                "symbol-alt-narrow": "₩"
            },
            KWD: {
                displayName: "dinaro kuwaitiano",
                "displayName-count-one": "dinaro kuwaitiano",
                "displayName-count-other": "dinari kuwaitiani",
                symbol: "KWD"
            },
            KYD: {
                displayName: "dollaro delle Isole Cayman",
                "displayName-count-one": "dollaro delle Isole Cayman",
                "displayName-count-other": "dollari delle Isole Cayman",
                symbol: "KYD",
                "symbol-alt-narrow": "$"
            },
            KZT: {
                displayName: "tenge kazako",
                "displayName-count-one": "tenge kazako",
                "displayName-count-other": "tenge kazaki",
                symbol: "KZT",
                "symbol-alt-narrow": "₸"
            },
            LAK: {
                displayName: "kip laotiano",
                "displayName-count-one": "kip laotiano",
                "displayName-count-other": "kip laotiani",
                symbol: "LAK",
                "symbol-alt-narrow": "₭"
            },
            LBP: {
                displayName: "lira libanese",
                "displayName-count-one": "lira libanese",
                "displayName-count-other": "lire libanesi",
                symbol: "LBP",
                "symbol-alt-narrow": "L£"
            },
            LKR: {
                displayName: "rupia di Sri Lanka",
                "displayName-count-one": "rupia di Sri Lanka",
                "displayName-count-other": "rupie di Sri Lanka",
                symbol: "LKR",
                "symbol-alt-narrow": "Rs"
            },
            LRD: {
                displayName: "dollaro liberiano",
                "displayName-count-one": "dollaro liberiano",
                "displayName-count-other": "dollari liberiani",
                symbol: "LRD",
                "symbol-alt-narrow": "$"
            },
            LSL: {
                displayName: "loti del Lesotho",
                symbol: "LSL"
            },
            LTL: {
                displayName: "litas lituano",
                "displayName-count-one": "litas lituano",
                "displayName-count-other": "litas lituani",
                symbol: "LTL",
                "symbol-alt-narrow": "Lt"
            },
            LTT: {
                displayName: "talonas lituani",
                symbol: "LTT"
            },
            LUC: {
                displayName: "franco convertibile del Lussemburgo",
                symbol: "LUC"
            },
            LUF: {
                displayName: "franco del Lussemburgo",
                symbol: "LUF"
            },
            LUL: {
                displayName: "franco finanziario del Lussemburgo",
                symbol: "LUL"
            },
            LVL: {
                displayName: "lats lettone",
                "displayName-count-one": "lats lettone",
                "displayName-count-other": "lati lettoni",
                symbol: "LVL",
                "symbol-alt-narrow": "Ls"
            },
            LVR: {
                displayName: "rublo lettone",
                symbol: "LVR"
            },
            LYD: {
                displayName: "dinaro libico",
                "displayName-count-one": "dinaro libico",
                "displayName-count-other": "dinari libici",
                symbol: "LYD"
            },
            MAD: {
                displayName: "dirham marocchino",
                "displayName-count-one": "dirham marocchino",
                "displayName-count-other": "dirham marocchini",
                symbol: "MAD"
            },
            MAF: {
                displayName: "franco marocchino",
                symbol: "MAF"
            },
            MCF: {
                displayName: "MCF",
                symbol: "MCF"
            },
            MDC: {
                displayName: "MDC",
                symbol: "MDC"
            },
            MDL: {
                displayName: "leu moldavo",
                "displayName-count-one": "leu moldavo",
                "displayName-count-other": "lei moldavi",
                symbol: "MDL"
            },
            MGA: {
                displayName: "ariary malgascio",
                "displayName-count-one": "ariary malgascio",
                "displayName-count-other": "ariary malgasci",
                symbol: "MGA",
                "symbol-alt-narrow": "Ar"
            },
            MGF: {
                displayName: "franco malgascio",
                symbol: "MGF"
            },
            MKD: {
                displayName: "denar macedone",
                "displayName-count-one": "dinaro macedone",
                "displayName-count-other": "dinari macedoni",
                symbol: "MKD"
            },
            MKN: {
                displayName: "MKN",
                symbol: "MKN"
            },
            MLF: {
                displayName: "franco di Mali",
                symbol: "MLF"
            },
            MMK: {
                displayName: "kyat di Myanmar",
                "displayName-count-one": "kyat di Myanmar",
                "displayName-count-other": "kyat di Myanmar",
                symbol: "MMK",
                "symbol-alt-narrow": "K"
            },
            MNT: {
                displayName: "tugrik mongolo",
                "displayName-count-one": "tugrik mongolo",
                "displayName-count-other": "tugrik mongoli",
                symbol: "MNT",
                "symbol-alt-narrow": "₮"
            },
            MOP: {
                displayName: "pataca di Macao",
                "displayName-count-one": "pataca di Macao",
                "displayName-count-other": "patacas di Macao",
                symbol: "MOP"
            },
            MRO: {
                displayName: "ouguiya della Mauritania",
                "displayName-count-one": "ouguiya della Mauritania",
                "displayName-count-other": "ouguiya della Mauritania",
                symbol: "MRO"
            },
            MTL: {
                displayName: "lira maltese",
                symbol: "MTL"
            },
            MTP: {
                displayName: "sterlina maltese",
                symbol: "MTP"
            },
            MUR: {
                displayName: "rupia mauriziana",
                "displayName-count-one": "rupia mauriziana",
                "displayName-count-other": "rupie mauriziane",
                symbol: "MUR",
                "symbol-alt-narrow": "Rs"
            },
            MVP: {
                displayName: "MVP",
                symbol: "MVP"
            },
            MVR: {
                displayName: "rufiyaa delle Maldive",
                "displayName-count-one": "rufiyaa delle Maldive",
                "displayName-count-other": "rufiyaa delle Maldive",
                symbol: "MVR"
            },
            MWK: {
                displayName: "kwacha malawiano",
                "displayName-count-one": "kwacha malawiano",
                "displayName-count-other": "kwacha malawiani",
                symbol: "MWK"
            },
            MXN: {
                displayName: "peso messicano",
                "displayName-count-one": "peso messicano",
                "displayName-count-other": "pesos messicani",
                symbol: "MXN",
                "symbol-alt-narrow": "$"
            },
            MXP: {
                displayName: "peso messicano d’argento (1861–1992)",
                symbol: "MXP"
            },
            MXV: {
                displayName: "unidad de inversion (UDI) messicana",
                symbol: "MXV"
            },
            MYR: {
                displayName: "ringgit malese",
                "displayName-count-one": "ringgit malese",
                "displayName-count-other": "ringgit malesi",
                symbol: "MYR",
                "symbol-alt-narrow": "RM"
            },
            MZE: {
                displayName: "escudo del Mozambico",
                symbol: "MZE"
            },
            MZM: {
                displayName: "MZM",
                symbol: "MZM"
            },
            MZN: {
                displayName: "metical mozambicano",
                "displayName-count-one": "metical mozambicano",
                "displayName-count-other": "metical mozambicani",
                symbol: "MZN"
            },
            NAD: {
                displayName: "dollaro namibiano",
                "displayName-count-one": "dollaro namibiano",
                "displayName-count-other": "dollari namibiani",
                symbol: "NAD",
                "symbol-alt-narrow": "$"
            },
            NGN: {
                displayName: "naira nigeriana",
                "displayName-count-one": "naira nigeriana",
                "displayName-count-other": "naire nigeriane",
                symbol: "NGN",
                "symbol-alt-narrow": "₦"
            },
            NIC: {
                displayName: "cordoba nicaraguense",
                "displayName-count-one": "cordoba nicaraguense",
                "displayName-count-other": "cordoba nicaraguense",
                symbol: "NIC"
            },
            NIO: {
                displayName: "córdoba nicaraguense",
                "displayName-count-one": "córdoba nicaraguense",
                "displayName-count-other": "córdoba nicaraguensi",
                symbol: "NIO",
                "symbol-alt-narrow": "C$"
            },
            NLG: {
                displayName: "fiorino olandese",
                symbol: "NLG"
            },
            NOK: {
                displayName: "corona norvegese",
                "displayName-count-one": "corona norvegese",
                "displayName-count-other": "corone norvegesi",
                symbol: "NOK",
                "symbol-alt-narrow": "NKr"
            },
            NPR: {
                displayName: "rupia nepalese",
                "displayName-count-one": "rupia nepalese",
                "displayName-count-other": "rupie nepalesi",
                symbol: "NPR",
                "symbol-alt-narrow": "Rs"
            },
            NZD: {
                displayName: "dollaro neozelandese",
                "displayName-count-one": "dollaro neozelandese",
                "displayName-count-other": "dollari neozelandesi",
                symbol: "NZ$",
                "symbol-alt-narrow": "$"
            },
            OMR: {
                displayName: "rial omanita",
                "displayName-count-one": "rial omanita",
                "displayName-count-other": "rial omaniti",
                symbol: "OMR"
            },
            PAB: {
                displayName: "balboa panamense",
                "displayName-count-one": "balboa panamense",
                "displayName-count-other": "balboa panamensi",
                symbol: "PAB"
            },
            PEI: {
                displayName: "inti peruviano",
                symbol: "PEI"
            },
            PEN: {
                displayName: "sol peruviano",
                "displayName-count-one": "sol peruviano",
                "displayName-count-other": "sol peruviani",
                symbol: "PEN"
            },
            PES: {
                displayName: "sol peruviano (1863–1965)",
                symbol: "PES"
            },
            PGK: {
                displayName: "kina papuana",
                "displayName-count-one": "kina papuana",
                "displayName-count-other": "kina papuane",
                symbol: "PGK"
            },
            PHP: {
                displayName: "peso filippino",
                "displayName-count-one": "peso filippino",
                "displayName-count-other": "pesos filippini",
                symbol: "PHP",
                "symbol-alt-narrow": "₱"
            },
            PKR: {
                displayName: "rupia pakistana",
                "displayName-count-one": "rupia pakistana",
                "displayName-count-other": "rupie pakistane",
                symbol: "PKR",
                "symbol-alt-narrow": "Rs"
            },
            PLN: {
                displayName: "złoty polacco",
                "displayName-count-one": "złoty polacco",
                "displayName-count-other": "złoty polacchi",
                symbol: "PLN",
                "symbol-alt-narrow": "zł"
            },
            PLZ: {
                displayName: "złoty Polacco (1950–1995)",
                "displayName-count-one": "złoty polacco (1950–1995)",
                "displayName-count-other": "złoty polacchi (1950–1995)",
                symbol: "PLZ"
            },
            PTE: {
                displayName: "escudo portoghese",
                symbol: "PTE"
            },
            PYG: {
                displayName: "guaraní paraguayano",
                "displayName-count-one": "guaraní paraguayano",
                "displayName-count-other": "guaraní paraguayani",
                symbol: "PYG",
                "symbol-alt-narrow": "₲"
            },
            QAR: {
                displayName: "rial qatariano",
                "displayName-count-one": "rial qatariano",
                "displayName-count-other": "rial qatariani",
                symbol: "QAR"
            },
            RHD: {
                displayName: "dollaro della Rhodesia",
                symbol: "RHD"
            },
            ROL: {
                displayName: "leu della Romania",
                symbol: "ROL"
            },
            RON: {
                displayName: "leu rumeno",
                "displayName-count-one": "leu rumeno",
                "displayName-count-other": "lei rumeni",
                symbol: "RON",
                "symbol-alt-narrow": "lei"
            },
            RSD: {
                displayName: "dinaro serbo",
                "displayName-count-one": "dinaro serbo",
                "displayName-count-other": "dinara serbi",
                symbol: "RSD"
            },
            RUB: {
                displayName: "rublo russo",
                "displayName-count-one": "rublo russo",
                "displayName-count-other": "rubli russi",
                symbol: "RUB",
                "symbol-alt-narrow": "₽"
            },
            RUR: {
                displayName: "rublo della CSI",
                symbol: "RUR",
                "symbol-alt-narrow": "р."
            },
            RWF: {
                displayName: "franco ruandese",
                "displayName-count-one": "franco ruandese",
                "displayName-count-other": "franchi ruandesi",
                symbol: "RWF",
                "symbol-alt-narrow": "RF"
            },
            SAR: {
                displayName: "riyal saudita",
                "displayName-count-one": "riyal saudita",
                "displayName-count-other": "riyal sauditi",
                symbol: "SAR"
            },
            SBD: {
                displayName: "dollaro delle Isole Salomone",
                "displayName-count-one": "dollaro delle Isole Salomone",
                "displayName-count-other": "dollari delle Isole Salomone",
                symbol: "SBD",
                "symbol-alt-narrow": "$"
            },
            SCR: {
                displayName: "rupia delle Seychelles",
                "displayName-count-one": "rupia delle Seychelles",
                "displayName-count-other": "rupie delle Seychelles",
                symbol: "SCR"
            },
            SDD: {
                displayName: "dinaro sudanese",
                symbol: "SDD"
            },
            SDG: {
                displayName: "sterlina sudanese",
                "displayName-count-one": "sterlina sudanese",
                "displayName-count-other": "sterline sudanesi",
                symbol: "SDG"
            },
            SDP: {
                displayName: "SDP",
                symbol: "SDP"
            },
            SEK: {
                displayName: "corona svedese",
                "displayName-count-one": "corona svedese",
                "displayName-count-other": "corone svedesi",
                symbol: "SEK",
                "symbol-alt-narrow": "kr"
            },
            SGD: {
                displayName: "dollaro di Singapore",
                "displayName-count-one": "dollaro di Singapore",
                "displayName-count-other": "dollari di Singapore",
                symbol: "SGD",
                "symbol-alt-narrow": "$"
            },
            SHP: {
                displayName: "sterlina di Sant’Elena",
                "displayName-count-one": "sterlina di Sant’Elena",
                "displayName-count-other": "sterline di Sant’Elena",
                symbol: "SHP",
                "symbol-alt-narrow": "£"
            },
            SIT: {
                displayName: "tallero sloveno",
                symbol: "SIT"
            },
            SKK: {
                displayName: "corona slovacca",
                symbol: "SKK"
            },
            SLL: {
                displayName: "leone della Sierra Leone",
                "displayName-count-one": "leone della Sierra Leone",
                "displayName-count-other": "leoni della Sierra Leone",
                symbol: "SLL"
            },
            SOS: {
                displayName: "scellino somalo",
                "displayName-count-one": "scellino somalo",
                "displayName-count-other": "scellini somali",
                symbol: "SOS"
            },
            SRD: {
                displayName: "dollaro del Suriname",
                "displayName-count-one": "dollaro del Suriname",
                "displayName-count-other": "dollari del Suriname",
                symbol: "SRD",
                "symbol-alt-narrow": "$"
            },
            SRG: {
                displayName: "fiorino del Suriname",
                symbol: "SRG"
            },
            SSP: {
                displayName: "sterlina sud-sudanese",
                "displayName-count-one": "sterlina sud-sudanese",
                "displayName-count-other": "sterline sud-sudanesi",
                symbol: "SSP",
                "symbol-alt-narrow": "£"
            },
            STD: {
                displayName: "dobra di Sao Tomé e Principe",
                "displayName-count-one": "dobra di Sao Tomé e Principe",
                "displayName-count-other": "dobra di Sao Tomé e Principe",
                symbol: "STD",
                "symbol-alt-narrow": "Db"
            },
            STN: {
                displayName: "STN",
                symbol: "STN"
            },
            SUR: {
                displayName: "rublo sovietico",
                symbol: "SUR"
            },
            SVC: {
                displayName: "colón salvadoregno",
                symbol: "SVC"
            },
            SYP: {
                displayName: "lira siriana",
                "displayName-count-one": "lira siriana",
                "displayName-count-other": "lire siriane",
                symbol: "SYP",
                "symbol-alt-narrow": "£"
            },
            SZL: {
                displayName: "lilangeni dello Swaziland",
                "displayName-count-one": "lilangeni dello Swaziland",
                "displayName-count-other": "lilangeni dello Swaziland",
                symbol: "SZL"
            },
            THB: {
                displayName: "baht thailandese",
                "displayName-count-one": "baht thailandese",
                "displayName-count-other": "baht thailandesi",
                symbol: "฿",
                "symbol-alt-narrow": "฿"
            },
            TJR: {
                displayName: "rublo del Tajikistan",
                symbol: "TJR"
            },
            TJS: {
                displayName: "somoni tagiko",
                "displayName-count-one": "somoni tagiko",
                "displayName-count-other": "somoni tagiki",
                symbol: "TJS"
            },
            TMM: {
                displayName: "manat turkmeno (1993–2009)",
                symbol: "TMM"
            },
            TMT: {
                displayName: "manat turkmeno",
                "displayName-count-one": "manat turkmeno",
                "displayName-count-other": "manat turkmeni",
                symbol: "TMT"
            },
            TND: {
                displayName: "dinaro tunisino",
                "displayName-count-one": "dinaro tunisino",
                "displayName-count-other": "dinari tunisini",
                symbol: "TND"
            },
            TOP: {
                displayName: "paʻanga tongano",
                "displayName-count-one": "paʻanga tongano",
                "displayName-count-other": "paʻanga tongani",
                symbol: "TOP",
                "symbol-alt-narrow": "T$"
            },
            TPE: {
                displayName: "escudo di Timor",
                symbol: "TPE"
            },
            TRL: {
                displayName: "lira turca (1922–2005)",
                "displayName-count-one": "lira turca (1922–2005)",
                "displayName-count-other": "lire turche (1922–2005)",
                symbol: "TRL"
            },
            TRY: {
                displayName: "lira turca",
                "displayName-count-one": "lira turca",
                "displayName-count-other": "lire turche",
                symbol: "TRY",
                "symbol-alt-narrow": "₺",
                "symbol-alt-variant": "TL"
            },
            TTD: {
                displayName: "dollaro di Trinidad e Tobago",
                "displayName-count-one": "dollaro di Trinidad e Tobago",
                "displayName-count-other": "dollari di Trinidad e Tobago",
                symbol: "TTD",
                "symbol-alt-narrow": "$"
            },
            TWD: {
                displayName: "nuovo dollaro taiwanese",
                "displayName-count-one": "nuovo dollaro taiwanese",
                "displayName-count-other": "nuovi dollari taiwanesi",
                symbol: "TWD",
                "symbol-alt-narrow": "NT$"
            },
            TZS: {
                displayName: "scellino della Tanzania",
                "displayName-count-one": "scellino della Tanzania",
                "displayName-count-other": "scellini della Tanzania",
                symbol: "TZS"
            },
            UAH: {
                displayName: "grivnia ucraina",
                "displayName-count-one": "grivnia ucraina",
                "displayName-count-other": "grivnie ucraine",
                symbol: "UAH",
                "symbol-alt-narrow": "₴"
            },
            UAK: {
                displayName: "karbovanetz ucraino",
                symbol: "UAK"
            },
            UGS: {
                displayName: "scellino ugandese (1966–1987)",
                symbol: "UGS"
            },
            UGX: {
                displayName: "scellino ugandese",
                "displayName-count-one": "scellino ugandese",
                "displayName-count-other": "scellini ugandesi",
                symbol: "UGX"
            },
            USD: {
                displayName: "dollaro statunitense",
                "displayName-count-one": "dollaro statunitense",
                "displayName-count-other": "dollari statunitensi",
                symbol: "USD",
                "symbol-alt-narrow": "$"
            },
            USN: {
                displayName: "dollaro statunitense (next day)",
                symbol: "USN"
            },
            USS: {
                displayName: "dollaro statunitense (same day)",
                symbol: "USS"
            },
            UYI: {
                displayName: "peso uruguaiano in unità indicizzate",
                symbol: "UYI"
            },
            UYP: {
                displayName: "peso uruguaiano (1975–1993)",
                symbol: "UYP"
            },
            UYU: {
                displayName: "peso uruguayano",
                "displayName-count-one": "peso uruguayano",
                "displayName-count-other": "pesos uruguayani",
                symbol: "UYU",
                "symbol-alt-narrow": "$"
            },
            UZS: {
                displayName: "sum uzbeco",
                "displayName-count-one": "sum uzbeco",
                "displayName-count-other": "sum uzbechi",
                symbol: "UZS"
            },
            VEB: {
                displayName: "bolivar venezuelano (1871–2008)",
                "displayName-count-one": "bolivar venezuelano (1871–2008)",
                "displayName-count-other": "bolivares venezuelani (1871–2008)",
                symbol: "VEB"
            },
            VEF: {
                displayName: "bolívar venezuelano",
                "displayName-count-one": "bolívar venezuelano",
                "displayName-count-other": "bolívares venezuelani",
                symbol: "VEF",
                "symbol-alt-narrow": "Bs"
            },
            VND: {
                displayName: "dong vietnamita",
                "displayName-count-one": "dong vietnamita",
                "displayName-count-other": "dong vietnamiti",
                symbol: "₫",
                "symbol-alt-narrow": "₫"
            },
            VNN: {
                displayName: "VNN",
                symbol: "VNN"
            },
            VUV: {
                displayName: "vatu di Vanuatu",
                "displayName-count-one": "vatu di Vanuatu",
                "displayName-count-other": "vatu di Vanuatu",
                symbol: "VUV"
            },
            WST: {
                displayName: "tala samoano",
                "displayName-count-one": "tala samoano",
                "displayName-count-other": "tala samoani",
                symbol: "WST"
            },
            XAF: {
                displayName: "franco CFA BEAC",
                "displayName-count-one": "franco CFA BEAC",
                "displayName-count-other": "franchi CFA BEAC",
                symbol: "FCFA"
            },
            XAG: {
                displayName: "argento",
                symbol: "XAG"
            },
            XAU: {
                displayName: "oro",
                symbol: "XAU"
            },
            XBA: {
                displayName: "unità composita europea",
                symbol: "XBA"
            },
            XBB: {
                displayName: "unità monetaria europea",
                symbol: "XBB"
            },
            XBC: {
                displayName: "unità di acconto europea (XBC)",
                symbol: "XBC"
            },
            XBD: {
                displayName: "unità di acconto europea (XBD)",
                symbol: "XBD"
            },
            XCD: {
                displayName: "dollaro dei Caraibi orientali",
                "displayName-count-one": "dollaro dei Caraibi orientali",
                "displayName-count-other": "dollari dei Caraibi orientali",
                symbol: "EC$",
                "symbol-alt-narrow": "$"
            },
            XDR: {
                displayName: "diritti speciali di incasso",
                symbol: "XDR"
            },
            XEU: {
                displayName: "XEU",
                symbol: "XEU"
            },
            XFO: {
                displayName: "franco oro francese",
                symbol: "XFO"
            },
            XFU: {
                displayName: "franco UIC francese",
                symbol: "XFU"
            },
            XOF: {
                displayName: "franco CFA BCEAO",
                "displayName-count-one": "franco CFA BCEAO",
                "displayName-count-other": "franchi CFA BCEAO",
                symbol: "CFA"
            },
            XPD: {
                displayName: "palladio",
                symbol: "XPD"
            },
            XPF: {
                displayName: "franco CFP",
                "displayName-count-one": "franco CFP",
                "displayName-count-other": "franchi CFP",
                symbol: "CFPF"
            },
            XPT: {
                displayName: "platino",
                symbol: "XPT"
            },
            XRE: {
                displayName: "fondi RINET",
                symbol: "XRE"
            },
            XSU: {
                displayName: "XSU",
                symbol: "XSU"
            },
            XTS: {
                displayName: "codice di verifica della valuta",
                symbol: "XTS"
            },
            XUA: {
                displayName: "XUA",
                symbol: "XUA"
            },
            XXX: {
                displayName: "valuta sconosciuta",
                "displayName-count-one": "(valuta sconosciuta)",
                "displayName-count-other": "(valute sconosciute)",
                symbol: "XXX"
            },
            YDD: {
                displayName: "dinaro dello Yemen",
                symbol: "YDD"
            },
            YER: {
                displayName: "riyal yemenita",
                "displayName-count-one": "rial yemenita",
                "displayName-count-other": "rial yemeniti",
                symbol: "YER"
            },
            YUD: {
                displayName: "dinaro forte yugoslavo",
                symbol: "YUD"
            },
            YUM: {
                displayName: "dinaro noviy yugoslavo",
                symbol: "YUM"
            },
            YUN: {
                displayName: "dinaro convertibile yugoslavo",
                symbol: "YUN"
            },
            YUR: {
                displayName: "YUR",
                symbol: "YUR"
            },
            ZAL: {
                displayName: "rand sudafricano (finanziario)",
                symbol: "ZAL"
            },
            ZAR: {
                displayName: "rand sudafricano",
                "displayName-count-one": "rand sudafricano",
                "displayName-count-other": "rand sudafricani",
                symbol: "ZAR",
                "symbol-alt-narrow": "R"
            },
            ZMK: {
                displayName: "kwacha dello Zambia (1968–2012)",
                "displayName-count-one": "kwacha zambiano (1968–2012)",
                "displayName-count-other": "kwacha zambiani (1968–2012)",
                symbol: "ZMK"
            },
            ZMW: {
                displayName: "kwacha dello Zambia",
                "displayName-count-one": "kwacha zambiano",
                "displayName-count-other": "kwacha zambiani",
                symbol: "ZMW",
                "symbol-alt-narrow": "ZK"
            },
            ZRN: {
                displayName: "nuovo zaire dello Zaire",
                symbol: "ZRN"
            },
            ZRZ: {
                displayName: "zaire dello Zaire",
                symbol: "ZRZ"
            },
            ZWD: {
                displayName: "dollaro dello Zimbabwe",
                symbol: "ZWD"
            },
            ZWL: {
                displayName: "dollaro zimbabwiano (2009)",
                symbol: "ZWL"
            },
            ZWR: {
                displayName: "ZWR",
                symbol: "ZWR"
            }
        },
        localeCurrency: "EUR"
    },
    calendar: {
        patterns: {
            d: "d/M/y",
            D: "EEEE d MMMM y",
            m: "d MMM",
            M: "d MMMM",
            y: "MMM y",
            Y: "MMMM y",
            F: "EEEE d MMMM y HH:mm:ss",
            g: "d/M/y HH:mm",
            G: "d/M/y HH:mm:ss",
            t: "HH:mm",
            T: "HH:mm:ss",
            s: "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
            u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'"
        },
        dateTimeFormats: {
            full: "{1} {0}",
            long: "{1} {0}",
            medium: "{1}, {0}",
            short: "{1}, {0}",
            availableFormats: {
                Bh: "h B",
                Bhm: "h:mm B",
                Bhms: "h:mm:ss B",
                d: "d",
                E: "ccc",
                EBhm: "E h:mm B",
                EBhms: "E h:mm:ss B",
                Ed: "E d",
                Ehm: "E h:mm a",
                EHm: "E HH:mm",
                Ehms: "E h:mm:ss a",
                EHms: "E HH:mm:ss",
                Gy: "y G",
                GyMMM: "MMM y G",
                GyMMMd: "d MMM y G",
                GyMMMEd: "E d MMM y G",
                h: "h a",
                H: "HH",
                hm: "h:mm a",
                Hm: "HH:mm",
                hms: "h:mm:ss a",
                Hms: "HH:mm:ss",
                hmsv: "h:mm:ss a v",
                Hmsv: "HH:mm:ss v",
                hmv: "h:mm a v",
                Hmv: "HH:mm v",
                M: "L",
                Md: "d/M",
                MEd: "E d/M",
                MMM: "LLL",
                MMMd: "d MMM",
                MMMEd: "E d MMM",
                MMMMd: "d MMMM",
                "MMMMW-count-one": "'settimana' W 'di' MMM",
                "MMMMW-count-other": "'settimana' W 'di' MMM",
                ms: "mm:ss",
                y: "y",
                yM: "M/y",
                yMd: "d/M/y",
                yMEd: "E d/M/y",
                yMMM: "MMM y",
                yMMMd: "d MMM y",
                yMMMEd: "E d MMM y",
                yMMMM: "MMMM y",
                yQQQ: "QQQ y",
                yQQQQ: "QQQQ y",
                "yw-count-one": "'settimana' w 'del' Y",
                "yw-count-other": "'settimana' w 'del' Y"
            }
        },
        timeFormats: {
            full: "HH:mm:ss zzzz",
            long: "HH:mm:ss z",
            medium: "HH:mm:ss",
            short: "HH:mm"
        },
        dateFormats: {
            full: "EEEE d MMMM y",
            long: "d MMMM y",
            medium: "d MMM y",
            short: "dd/MM/yy"
        },
        days: {
            format: {
                abbreviated: [
                    "dom",
                    "lun",
                    "mar",
                    "mer",
                    "gio",
                    "ven",
                    "sab"
                ],
                narrow: [
                    "D",
                    "L",
                    "M",
                    "M",
                    "G",
                    "V",
                    "S"
                ],
                short: [
                    "dom",
                    "lun",
                    "mar",
                    "mer",
                    "gio",
                    "ven",
                    "sab"
                ],
                wide: [
                    "domenica",
                    "lunedì",
                    "martedì",
                    "mercoledì",
                    "giovedì",
                    "venerdì",
                    "sabato"
                ]
            },
            "stand-alone": {
                abbreviated: [
                    "dom",
                    "lun",
                    "mar",
                    "mer",
                    "gio",
                    "ven",
                    "sab"
                ],
                narrow: [
                    "D",
                    "L",
                    "M",
                    "M",
                    "G",
                    "V",
                    "S"
                ],
                short: [
                    "dom",
                    "lun",
                    "mar",
                    "mer",
                    "gio",
                    "ven",
                    "sab"
                ],
                wide: [
                    "domenica",
                    "lunedì",
                    "martedì",
                    "mercoledì",
                    "giovedì",
                    "venerdì",
                    "sabato"
                ]
            }
        },
        months: {
            format: {
                abbreviated: [
                    "gen",
                    "feb",
                    "mar",
                    "apr",
                    "mag",
                    "giu",
                    "lug",
                    "ago",
                    "set",
                    "ott",
                    "nov",
                    "dic"
                ],
                narrow: [
                    "G",
                    "F",
                    "M",
                    "A",
                    "M",
                    "G",
                    "L",
                    "A",
                    "S",
                    "O",
                    "N",
                    "D"
                ],
                wide: [
                    "gennaio",
                    "febbraio",
                    "marzo",
                    "aprile",
                    "maggio",
                    "giugno",
                    "luglio",
                    "agosto",
                    "settembre",
                    "ottobre",
                    "novembre",
                    "dicembre"
                ]
            },
            "stand-alone": {
                abbreviated: [
                    "gen",
                    "feb",
                    "mar",
                    "apr",
                    "mag",
                    "giu",
                    "lug",
                    "ago",
                    "set",
                    "ott",
                    "nov",
                    "dic"
                ],
                narrow: [
                    "G",
                    "F",
                    "M",
                    "A",
                    "M",
                    "G",
                    "L",
                    "A",
                    "S",
                    "O",
                    "N",
                    "D"
                ],
                wide: [
                    "gennaio",
                    "febbraio",
                    "marzo",
                    "aprile",
                    "maggio",
                    "giugno",
                    "luglio",
                    "agosto",
                    "settembre",
                    "ottobre",
                    "novembre",
                    "dicembre"
                ]
            }
        },
        quarters: {
            format: {
                abbreviated: [
                    "T1",
                    "T2",
                    "T3",
                    "T4"
                ],
                narrow: [
                    "1",
                    "2",
                    "3",
                    "4"
                ],
                wide: [
                    "1º trimestre",
                    "2º trimestre",
                    "3º trimestre",
                    "4º trimestre"
                ]
            },
            "stand-alone": {
                abbreviated: [
                    "T1",
                    "T2",
                    "T3",
                    "T4"
                ],
                narrow: [
                    "1",
                    "2",
                    "3",
                    "4"
                ],
                wide: [
                    "1º trimestre",
                    "2º trimestre",
                    "3º trimestre",
                    "4º trimestre"
                ]
            }
        },
        dayPeriods: {
            format: {
                abbreviated: {
                    midnight: "mezzanotte",
                    am: "AM",
                    noon: "mezzogiorno",
                    pm: "PM",
                    morning1: "di mattina",
                    afternoon1: "del pomeriggio",
                    evening1: "di sera",
                    night1: "di notte"
                },
                narrow: {
                    midnight: "mezzanotte",
                    am: "m.",
                    noon: "mezzogiorno",
                    pm: "p.",
                    morning1: "di mattina",
                    afternoon1: "del pomeriggio",
                    evening1: "di sera",
                    night1: "di notte"
                },
                wide: {
                    midnight: "mezzanotte",
                    am: "AM",
                    noon: "mezzogiorno",
                    pm: "PM",
                    morning1: "di mattina",
                    afternoon1: "del pomeriggio",
                    evening1: "di sera",
                    night1: "di notte"
                }
            },
            "stand-alone": {
                abbreviated: {
                    midnight: "mezzanotte",
                    am: "AM",
                    noon: "mezzogiorno",
                    pm: "PM",
                    morning1: "mattina",
                    afternoon1: "pomeriggio",
                    evening1: "sera",
                    night1: "notte"
                },
                narrow: {
                    midnight: "mezzanotte",
                    am: "m.",
                    noon: "mezzogiorno",
                    pm: "p.",
                    morning1: "mattina",
                    afternoon1: "pomeriggio",
                    evening1: "sera",
                    night1: "notte"
                },
                wide: {
                    midnight: "mezzanotte",
                    am: "AM",
                    noon: "mezzogiorno",
                    pm: "PM",
                    morning1: "mattina",
                    afternoon1: "pomeriggio",
                    evening1: "sera",
                    night1: "notte"
                }
            }
        },
        eras: {
            format: {
                wide: {
                    0: "avanti Cristo",
                    1: "dopo Cristo",
                    "0-alt-variant": "avanti Era Volgare",
                    "1-alt-variant": "Era Volgare"
                },
                abbreviated: {
                    0: "a.C.",
                    1: "d.C.",
                    "0-alt-variant": "a.E.V.",
                    "1-alt-variant": "E.V."
                },
                narrow: {
                    0: "aC",
                    1: "dC",
                    "0-alt-variant": "BCE",
                    "1-alt-variant": "CE"
                }
            }
        },
        gmtFormat: "GMT{0}",
        gmtZeroFormat: "GMT",
        dateFields: {
            era: {
                wide: "era",
                short: "era",
                narrow: "era"
            },
            year: {
                wide: "anno",
                short: "anno",
                narrow: "anno"
            },
            quarter: {
                wide: "trimestre",
                short: "trim.",
                narrow: "trim."
            },
            month: {
                wide: "mese",
                short: "mese",
                narrow: "mese"
            },
            week: {
                wide: "settimana",
                short: "sett.",
                narrow: "sett."
            },
            weekOfMonth: {
                wide: "settimana del mese",
                short: "sett. mese",
                narrow: "sett. mese"
            },
            day: {
                wide: "giorno",
                short: "g",
                narrow: "g"
            },
            dayOfYear: {
                wide: "giorno dell’anno",
                short: "giorno anno",
                narrow: "giorno anno"
            },
            weekday: {
                wide: "giorno della settimana",
                short: "giorno settimana",
                narrow: "giorno sett."
            },
            weekdayOfMonth: {
                wide: "giorno del mese",
                short: "giorno mese",
                narrow: "giorno mese"
            },
            dayperiod: {
                short: "AM/PM",
                wide: "AM/PM",
                narrow: "AM/PM"
            },
            hour: {
                wide: "ora",
                short: "h.",
                narrow: "h"
            },
            minute: {
                wide: "minuto",
                short: "min",
                narrow: "min"
            },
            second: {
                wide: "secondo",
                short: "s",
                narrow: "s"
            },
            zone: {
                wide: "fuso orario",
                short: "fuso",
                narrow: "fuso"
            }
        }
    },
    firstDay: 1,
    likelySubtags: {
        it: "it-Latn-IT"
    }
});




//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-intl/locales/it/all.js
// module id = ../../../../@progress/kendo-angular-intl/locales/it/all.js
// module chunks = vendor